import React, {useEffect, useRef, useState} from 'react'

import t from 'helpers/I18n'

import PropTypes from 'prop-types';
import StepsLoader from "../steps-loader";
import BaseParagraph from "../../base-components/base-paragraph";
import InputField from "../../base-components/base-input";
import StepFooterAction from "../../base-components/step-footer-action";
import BottomSheet from '../../modals/bottom-sheet';
import { HiOutlineLightBulb } from 'react-icons/hi'
// HiOutlineLightBulb

const HasEnterpriseName = ({ _step_service, error, step_ID, step_URL, next_step, step_form, setDataToContext, getDataFromContext }) => {
  const name = step_ID
  const checkboxID = "enterprise_name_use_fullname"
  const form = useRef()
    const data = getDataFromContext(step_ID)
    const [isLoading, setIsLoading] = useState(false)
    const [showModal, setShowModal] = useState(false)
    const [inputData, setInputData] = useState({ ...data })
    const [isValid, setIsValid] = useState(false)
  

    const getInputValue = (name, value) => {
        setInputData({
            ...inputData,
            [name] : value
        })
        setDataToContext(step_ID, step_URL, name, value)
    }

    useEffect(()=> {
        setIsValid(isValidForm())
    }, [inputData])

    useEffect(() => {
        if (window.PageBus) {
            window.PageBus.publish("analyticsServices", {
                pageID: "onboarding",
                stepSeq: "3",
                stepName: "pro info:what is your company name",
                flowType: "sales",
                flowName: "onboarding",
                productName: "onboarding",
                trackMethod: "flow"
            });
        }
    }, [])

    const action = () => {
         _step_service({step_ID, setIsLoading, next_step: "has-establishment-date"})
    }

    const isValidForm = () => {
        
        return [...form.current.elements].every(element => {
            return element.value !== "" && element.value !== " "
        })
    }
    return (
        <>
            <StepsLoader step_ID={step_ID} loading={isLoading}>
                <form ref={form}>
                    <BaseParagraph>
                        <h3>{t('pro_infos.pro_info_what_is_your_company_name.title')}</h3>                       
                       
                          <InputField
                            label={t('pro_infos.pro_info_what_is_your_company_name.label')}
                            value={inputData[name]}
                            name={name}
                            getInputValue={getInputValue}
                            error={error}
                            getDataFromContext={getDataFromContext}
              />

                    </BaseParagraph>
                </form>
                <StepFooterAction caption={t('general.continue')} action={action} link={next_step} disabled={!isValid} />

            </StepsLoader>
        </>
    )
}

HasEnterpriseName.propTypes = {
    name: PropTypes.string
}

HasEnterpriseName.defaultProps = {
    name: "email-step"
}


export default HasEnterpriseName